module.exports = __webpack_public_path__ + "media/icons/pochodzenie-polska-blue-374660e6.png";